import type { SplitFeatureFlag } from '@/utils/split/splitConfig';

import { useSplitTreatments } from '@splitsoftware/splitio-react';

type Treatment = {
  treatment: string;
  config: string | null;
};

type FeatureFlagResult = {
  isReady: boolean;
  isFeatureFlagEnabled: boolean;
  treatment: string;
  config: unknown;
};

export const useSplitFeatureFlag = (flag: SplitFeatureFlag): FeatureFlagResult => {
  const { treatments, isReady } = useSplitTreatments({
    names: [flag],
  });

  const treatment = treatments[flag] as Treatment;
  const isFeatureFlagEnabled = treatment?.treatment === 'on';

  return {
    isReady,
    isFeatureFlagEnabled,
    treatment: treatment?.treatment ?? 'off',
    config: treatment?.config ?? null,
  };
};
